import { FC, useEffect, useRef, useState } from 'react';
import { formatSavedDate, formatVideosCount, getScreenDimensions } from '../../utils/helper';
import { Tooltip } from '@mui/material';
import images from '../../assets/images';
import './PreviousMeetings.scss';
import BottomAdvertisement from '../BottomAdvertisement/BottomAdvertisement';
import { Advertisement, ScreenImages } from '../AdminRightSideAd/AdminRightSideAd';
import { useLocation } from 'react-router-dom';
import axios, { AxiosResponse } from 'axios';
import { RecorderPtaMeetingType } from '../../pages/AdminPta/AdminPta';


interface PropsType{
    savedSessionsList: RecorderPtaMeetingType[] | undefined;
    setClickedVideoUrl: (val: string) => void;
    setClickedVideoData: (video: RecorderPtaMeetingType) => void;
    isSearchClick?: boolean;
}

const PreviousMeetings:FC<PropsType> = ({ setClickedVideoUrl, savedSessionsList, setClickedVideoData, isSearchClick }) => {
  const { videoPlayIcon } = images;
  const baseURL = process.env.REACT_APP_FRONTEND_URL;
  const [isDescOverflow,setIsDescOverflow] = useState<boolean[]>([]);
  const videoDescriptionRef = useRef<(HTMLSpanElement | null)[]>([]);
  const [advertisements, setAdvertisement] = useState<string[]>([]);
  const [screenImages, setScreenImages] = useState<ScreenImages[]>([]);
  const katonCms = process.env.REACT_APP_KATON_CMS_SITE;
  const [loading,setLoading] = useState<boolean>(false)
  const location = useLocation();
  const { isMobileScreen } = getScreenDimensions();
  const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase());


  const checkOverflowVideoDescription = (index:number) => {
    if(videoDescriptionRef.current[index]){
      const overflow = (videoDescriptionRef.current[index]!.scrollHeight - 1) > videoDescriptionRef.current[index]!.clientHeight;
      setIsDescOverflow(prev => {
        const newOverflow = [...prev];
        newOverflow[index] = overflow;
        return newOverflow;
      });
    }
  }

  const handleClickVideo = (videoItem: RecorderPtaMeetingType) => {
    setClickedVideoUrl(baseURL && videoItem?.savedSessionUrl ? baseURL + videoItem?.savedSessionUrl : "");
    setClickedVideoData(videoItem);
  }

  const handleLoadedMetadata = (event: React.SyntheticEvent<HTMLVideoElement>) => {
    const videoElement = event.currentTarget;
    videoElement.currentTime = 1.2;
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response: AxiosResponse<Advertisement[]> = await axios.get(
          `${katonCms}/class_room_advertisement`,
          {
            headers: {
              "X-Hash-Key": process.env.REACT_APP_KATON_SITE_API_KEY,
            },
          }
        );
        const advertisements = response.data;
        const role = localStorage.getItem("role") || "";

        const schoolAdminScreens: Record<string, string[]> = advertisements
          .filter((ad: Advertisement) =>
            ad.categories
              .map((category) => category.toLowerCase())
              .includes(role)
          )
          .reduce((acc: Record<string, string[]>, ad: Advertisement) => {
            const { Screen, Image } = ad;
            if (!acc[Screen]) {
              acc[Screen] = [];
            }
            acc[Screen].push(`${katonCms?.split("/wp-json")[0]}${Image}`);
            return acc;
          }, {});

        const result: ScreenImages[] = Object.keys(schoolAdminScreens).map(
          (screen: string) => ({
            screen,
            images: schoolAdminScreens[screen],
          })
        );
        setScreenImages(result)
      } catch (error) {
        console.log(error);
      }finally {
        setLoading(false); // Stop the loader
      }
    };

    fetchData();
  }, []);

  useEffect(()=>{
    const handleAdvertisement = () => {
  
      const lowercaseScreen = (screen: string) => screen.toLowerCase();
      let ad: ScreenImages | undefined;
       if (location.pathname === '/pta-meetings') {
        ad = screenImages.find(ad => lowercaseScreen(ad.screen) === "generalmeetings");
    }
    else if (location.pathname === '/teacher-pta') {
      ad = screenImages.find(ad => lowercaseScreen(ad.screen) === "ptameetings");
  }
      if (ad) {
          setAdvertisement(ad.images);
      } else {
          setAdvertisement([]);
      }
  };
    handleAdvertisement();
  },[screenImages])

  const [showAdvertisement, setShowAdvertisement] = useState(true);

  const handleCloseAdvertisement = () => {
    setShowAdvertisement(false);
  };

   return (
    <>
      {!isSearchClick && <div className='savedSessionDivider'>
        <div className='labelContainer'>
          <div className='titleStyle'>Previous Meetings</div>
          {isMobileScreen && <div className='titleStyle'>{"-"}</div>}
          <div className='subTitleStyle'>{formatVideosCount(savedSessionsList?.length || 0)}</div>
        </div>
        <div className='divider' />
      </div>}
      
      <div className={(savedSessionsList && savedSessionsList?.length > 0) ? 'savedSessionsMainContainer' : 'noData'}>
      {localStorage.getItem('generalCode') === location?.state?.category?.mcCode && showAdvertisement && advertisements[0] && (
        <>
          <BottomAdvertisement adImage={advertisements[0]} handlecloseAd= {handleCloseAdvertisement} showcloseIcon={true}/>
        </>
      )}
        {(savedSessionsList && savedSessionsList?.length > 0) ? (
          <div className='savedSessionListContainerPta'>
            { savedSessionsList.map((videoItem: RecorderPtaMeetingType, index: number) => (
              <div className='videoContainer' key={`${index}-${videoItem?.cId}`} onClick={() => handleClickVideo(videoItem)}>
                      <video src={videoItem?.savedSessionUrl ? `${baseURL}${videoItem?.savedSessionUrl}${isSafariBrowser?'#t=0.001':''}` : ''} muted loop className='videoTagStyle' onCanPlay={(event) =>  handleLoadedMetadata(event)}/>
                      <div className='descriptionContainer'>
                      <div className='savedDateStyle'>{formatSavedDate(videoItem?.createdAt)}</div>
                      <Tooltip title={videoItem?.topic} disableHoverListener={!isDescOverflow[index]}>
                          <div className='descriptionStyle' onMouseEnter={() => checkOverflowVideoDescription(index)} onMouseMove={() => checkOverflowVideoDescription(index)} ref={(el) => (videoDescriptionRef.current[index] = el)}>
                            {videoItem?.topic}
                          </div>
                      </Tooltip>
                  </div>
                  <img src={videoPlayIcon} className='playIconStyle' alt='videoPlayIcon'/>
              </div>
            ))}
          </div>
          ) : (
          (!showAdvertisement || isMobileScreen) && <div className='noDataFoundStyle'>No video archive</div>
        )}
      </div>
    </>
  )
}

export default PreviousMeetings;
